import type { Result } from '@components/Maps/WindyWrapper'

export const getResultData = (result: Result | undefined | 0, coordinates: number[][], point: number[]) => {
  let routeData

  if (result) {
    const { position } = result
    const data = coordinates.splice(0, position)
    data.push(point)
    coordinates.unshift(point)
    routeData = data.map(item => ({ lat: item[1], lng: item[0] }))
  } else {
    routeData = coordinates
  }

  return { routeData, coordinates }
}

export const getRemainingData = (result: Result | undefined | 0, coordinates: number[][], point: number[]) => {
  let remainingRouteData

  if (result) {
    const { position } = result
    const data = coordinates.slice(position)
    data.unshift(point)
    remainingRouteData = data.map(item => ({ lat: item[1], lng: item[0] }))
  } else {
    remainingRouteData = coordinates.map(item => ({ lat: item[1], lng: item[0] }))
  }

  return { remainingRouteData, coordinates }
}
